export const DELIVERY_SPEED_SUFFIX = {
    SELECTED: "_SELECTED",
    UNSELECTED: "_UNSELECTED",
};

const DELIVERY_SPEED_TOOLTIP = "DELIVERY_SPEED_TOOLTIP";

export const DELIVERY_SPEED_WIDGET_TEST_IDS = {
    DELIVERY_SPEED_WIDGET_ID: "DELIVERY_SPEED_WIDGET",
    DELIVERY_SPEED_ITEM: "DELIVERY_SPEED_ITEM",
    DELIVERY_SPEED_INFO: "DELIVERY_SPEED_INFO",
    DELIVERY_SPEED_OPT_IN_WIDGET: "DELIVERY_SPEED_OPT_IN_WIDGET",
    DELIVERY_SPEED_STANDARD_SELECTED: `DELIVERY_SPEED_STANDARD${DELIVERY_SPEED_SUFFIX.SELECTED}`,
    DELIVERY_SPEED_STANDARD_UNSELECTED: `DELIVERY_SPEED_STANDARD${DELIVERY_SPEED_SUFFIX.UNSELECTED}`,
    DELIVERY_SPEED_NO_RUSH_SELECTED: `DELIVERY_SPEED_NO_RUSH${DELIVERY_SPEED_SUFFIX.SELECTED}`,
    DELIVERY_SPEED_NO_RUSH_UNSELECTED: `DELIVERY_SPEED_NO_RUSH${DELIVERY_SPEED_SUFFIX.UNSELECTED}`,
    DELIVERY_SPEED_EXPRESS_SELECTED: `DELIVERY_SPEED_EXPRESS${DELIVERY_SPEED_SUFFIX.SELECTED}`,
    DELIVERY_SPEED_EXPRESS_UNSELECTED: `DELIVERY_SPEED_EXPRESS${DELIVERY_SPEED_SUFFIX.UNSELECTED}`,
    DELIVERY_SPEED_NO_RUSH_ECO_SAVER_LOTTIE: `DELIVERY_SPEED_NO_RUSH_ECO_SAVER_LOTTIE`,
    DELIVERY_SPEED_NUDGE: "DELIVERY_SPEED_NUDGE",
    DELIVERY_SPEED_POPUP: "DELIVERY_SPEED_POPUP",
    DELIVERY_SPEED_BULLET_POINT: "DELIVERY_SPEED_BULLET_POINT",
    DELIVERY_SPEED_TOOLTIP_TITLE: `${DELIVERY_SPEED_TOOLTIP}_TITLE`,
    DELIVERY_SPEED_TOOLTIP_DESCRIPTION: `${DELIVERY_SPEED_TOOLTIP}_DESCRIPTION`,
    DELIVERY_SPEED_EXPRESS_BANNER: "DELIVERY_SPEED_EXPRESS_BANNER",
    DELIVERY_SPEED_EXPRESS_BANNER_TEXT: "DELIVERY_SPEED_EXPRESS_BANNER_TEXT",
    DELIVERY_SPEED_ITEM_SUBHEADING_STANDARD: "DELIVERY_SPEED_ITEM_SUBHEADING_STANDARD",
    DELIVERY_SPEED_ITEM_SUBHEADING_BATCH_NO_RUSH: "DELIVERY_SPEED_ITEM_SUBHEADING_BATCH_NO_RUSH",
    DELIVERY_SPEED_ITEM_SUBHEADING_EXPRESS: "DELIVERY_SPEED_ITEM_SUBHEADING_EXPRESS",
    DELIVERY_SPEED_ITEM_SUBHEADING_LAST_OPTION: "DELIVERY_SPEED_ITEM_SUBHEADING_LAST_OPTION",
    DELIVERY_SPEED_ITEM_OFFERS: "DELIVERY_SPEED_ITEM_OFFERS",
    DELIVERY_SPEED_ITEM_ICON_STANDARD: "DELIVERY_SPEED_ITEM_ICON_STANDARD",
    DELIVERY_SPEED_ITEM_ICON_BATCH_NO_RUSH: "DELIVERY_SPEED_ITEM_ICON_BATCH_NO_RUSH",
    DELIVERY_SPEED_ITEM_ICON_EXPRESS: "DELIVERY_SPEED_ITEM_ICON_EXPRESS",
    DELIVERY_SPEED_PRESENTATION_BANNER_CONTAINER: "DELIVERY_SPEED_PRESENTATION_BANNER_CONTAINER",
    DELIVERY_SPEED_PRESENTATION_BANNER_TEXT: "DELIVERY_SPEED_PRESENTATION_BANNER_TEXT",
    DELIVERY_SPEED_PRESENTATION_BANNER_IMAGE: "DELIVERY_SPEED_PRESENTATION_BANNER_IMAGE",
};
